function get( url, options = {}) {
    /* Check for method in options */
    if (
        options.method == undefined ||
        options.method.toUpper != 'GET'
    ) {
        /* Set */
        options.method = 'GET'
    }
    
    /* Return */
    return send( url, options )
}

function post( url, options = {} ) {
    /* Check for method in options */
    if (
        options.method == undefined ||
        options.method.toUpper != 'POST'
    ) {
        /* Set */
        options.method = 'POST'
    }

    /* Return */
    return send( url, options )
}

function send( url, options ) {
    /* Check for body param */
    if (
        options.body != undefined
    ) {
        /* Setup */
        let formData = new FormData()

        /* Set */
        if ( typeof options.body == 'object' ) {
            /* Iterate */
            for ( let key in options.body ) {
                if (options.body.hasOwnProperty( key ) ) {
                    formData.set( key, options.body[key] )
                }
            }

            /* Replace */
            options.body = formData
        }
    }

    /* Return */
    return fetch(
        url,
        options
    )
    .then((response) => {
        /* Check for anything else then status 200 */
        if (response.ok && response.status >= 200 && response.status < 300) {
            return response
        }

        /* Throw error */
        throw new Error('Something went wrong');
    })
    .then((response) => {
        return response.text()
    })
    .then((content) => {
        try {
            let json_data = JSON.parse(content)
            return json_data
        } catch {
            return content
        }
    })
    .catch((error) => {
        console.log(error)
    })
}

export {get, post}